"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapContentfulPageData = exports.trimKeys = exports.mapGlobalElements = void 0;
const tslib_1 = require("tslib");
const get_1 = tslib_1.__importDefault(require("lodash/get"));
const removeUndefined_1 = tslib_1.__importDefault(require("../../general/removeUndefined"));
const CONTENT_TYPES = {
    GLOBAL_ELEMENTS: 'globalElements'
};
/**
 * Maps global elements entry into a flatter key value map. This
 * function recurses into all copy groups and preseves the group
 * structure (eg. copy.group1.field1 is possible)
 *
 * @param {IGlobalElements[]} items
 * @returns {IGlobalElementsSlim}
 */
const mapGlobalElements = (items) => {
    return items.reduce((acc, item) => {
        const { key, value, copy } = item;
        acc[key] = value;
        if (copy) {
            acc[key] = Object.assign(Object.assign({}, (0, exports.mapGlobalElements)(copy)), { __isGroup: true });
        }
        else {
            acc[key] = mapContentfulPageDataWithMeta(value);
        }
        return acc;
    }, {});
};
exports.mapGlobalElements = mapGlobalElements;
/**
 * Recursively removes keys from a data structure with any amount of
 * nesting. This is useful for removing metadata or unwanted keys
 * from contentful. `data` can be object or an array of objects.
 *
 * @param {object | array} data
 * @param {string[]} keys
 * @returns {object | array}
 */
const trimKeys = (data) => {
    if (data === null || data === undefined)
        return data;
    if (Array.isArray(data))
        return data.map((item) => (0, exports.trimKeys)(item));
    let obj = {};
    for (const key in data) {
        if (key === 'data' && (data === null || data === void 0 ? void 0 : data.nodeType) === 'embedded-entry-inline') {
            obj[key] = data[key];
            continue;
        }
        if (key === 'sys')
            continue;
        if (typeof data[key] === 'object') {
            obj[key] = (0, exports.trimKeys)(data[key]);
        }
        else {
            obj[key] = data[key];
        }
    }
    return obj;
};
exports.trimKeys = trimKeys;
/**
 * Maps contentful page data to a more usable format
 *
 * @param data
 * @returns
 */
const mapContentfulPageDataWithMeta = (data) => {
    // if there are multiple nodes, map each one
    if (Array.isArray(data)) {
        return data.map((nodeData) => mapContentfulPageDataWithMeta(nodeData));
    }
    // each contentful model can be mapped differently.
    const contentType = (0, get_1.default)(data, 'sys.contentType.sys.id', '');
    const nodeType = (0, get_1.default)(data, 'nodeType');
    // if this is rich text return as is
    if (nodeType === 'document') {
        return data;
    }
    // GLOBAL_ELEMENTS: create a lookup map
    if (contentType === CONTENT_TYPES.GLOBAL_ELEMENTS) {
        const copyItems = (0, get_1.default)(data, 'copy', []);
        return (0, exports.mapGlobalElements)(copyItems);
    }
    // OTHER: assume all other unknown objects are a reference to another model entry
    if (typeof data === 'object' && contentType) {
        const fieldIds = Object.keys(data);
        return fieldIds.reduce((acc, fieldId) => {
            acc[fieldId] = mapContentfulPageDataWithMeta(data[fieldId]);
            return acc;
        }, {});
    }
    // any non-object data is return as is (eg. bool, string, etc)
    return data;
};
/**
 * Maps contentful page data to a more usable format. Removes undefined
 * fields, metadata and flattens global elements into a dictionary
 *
 * @param {ContentfulRawPageResp} data
 * @returns {SlimContentfulPageResp}
 */
const mapContentfulPageData = (data) => {
    return (0, exports.trimKeys)((0, removeUndefined_1.default)(mapContentfulPageDataWithMeta(data)));
};
exports.mapContentfulPageData = mapContentfulPageData;
exports.default = exports.mapContentfulPageData;
//# sourceMappingURL=mapContentfulPageData.js.map